import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../../constants/path';
import { STATIC_ROOT, FAQ_ID_WHY_CASHBACK_INVALIDATED } from '../../../../../constants';

import SvgComponent from '../../../../SvgComponent';
import LocalizedNavLink from '../../../../router/LocalizedNavLink';

class CashbackHistoryLegendComponent extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <section className="legends" aria-labelledby="cashback-legend-title">
                <h2 id="cashback-legend-title" className="sr-only">
                    {i18n.LEGEND_TITLE}
                </h2>
                <div className="legend flex-container-v">
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-validation.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.VALID}</span> : {i18n.VALID_MESSAGE}
                        </p>
                    </div>
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-pending.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.WAITING}</span> : {i18n.WAITING_MESSAGE}
                        </p>
                    </div>
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-invalide.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.INVALID}</span> : {i18n.INVALID_MESSAGE}{' '}
                            <LocalizedNavLink
                                to={`${PATH.FAQ_PATH}${
                                    FAQ_ID_WHY_CASHBACK_INVALIDATED
                                        ? `#${FAQ_ID_WHY_CASHBACK_INVALIDATED}`
                                        : ''
                                }`}>
                                {i18n.WHY_INVALID_MESSAGE}
                            </LocalizedNavLink>
                        </p>
                    </div>
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/icon/picto-check.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.PAID}</span> : {i18n.MESSAGE_PAYE}
                        </p>
                    </div>
                    <div className="label flex-container-h flex-center-alt">
                        <SvgComponent
                            src={`${STATIC_ROOT}/picto-ebon.svg`}
                            width={20}
                            height={20}
                            aria-hidden="true"
                            focusable="false"
                        />
                        <p>
                            <span>{i18n.EBON_LEGEND}</span> : {i18n.EBON_MESSAGE}
                        </p>
                    </div>
                </div>
            </section>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT
    };
}

export default connect(mapStateToProps)(CashbackHistoryLegendComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/history/CashbackHistoryLegendComponent.js